import {
  CREATE_DATE_PLACEHOLDER,
  LOAD_DATE_PLACEHOLDERS_BY_BOOK_ID,
  ASSIGN_IMAGE_TO_PLACEHOLDER } from './../../action-types/entities/datePlaceholders';
import { generateId } from '../../helpers/index';

export const STATE_KEY = 'datePlaceholders';

export const datePlaceholders = (state = {
  byId: {},
  allIds: [],
}, action) => {
  switch (action.type) {
    case CREATE_DATE_PLACEHOLDER: {
      const { datePlaceholder } = action;
      datePlaceholder.id = generateId(state.allIds);
      return {
        byId: {
          ...state.byId,
          [datePlaceholder.id]: datePlaceholder,
        },
        allIds: [...state.allIds, datePlaceholder.id],
      };
    }

    case LOAD_DATE_PLACEHOLDERS_BY_BOOK_ID: {
      return action.bookState;
    }

    case ASSIGN_IMAGE_TO_PLACEHOLDER: {
      const { placeholderId, dateImage } = action;

      return {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            dateImage,
          },
        },
        allIds: [...state.allIds],
      };
    }

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/redux/reducers/entities/datePlaceholders.js